export default __webpack_public_path__ + "static/media/5.ad2f93ea.jpg";